import {
  IconDefinition,
  IconName,
  faBell,
  faCat,
  faDog,
  faQuestion,
  faStethoscope,
  faUser,
} from "@fortawesome/pro-regular-svg-icons";

import { AppointmentKindSlug } from "common/types/scheduler";

export const RESOURCE_ICON_OPTIONS = [faStethoscope, faUser, faDog, faCat, faBell, faQuestion];

export const RESOURCE_ICON_NAME_TO_ICON = RESOURCE_ICON_OPTIONS.reduce(
  (map, icon) => ({ ...map, [icon.iconName]: icon }),
  {} as Record<IconName, IconDefinition | undefined>,
);

export const appointmentKindToExoticKind: Partial<
  Record<AppointmentKindSlug, AppointmentKindSlug>
> = {
  [AppointmentKindSlug.ExamInjuryIllness]: AppointmentKindSlug.ExamInjuryIllnessExotic,
  [AppointmentKindSlug.ExamWellness]: AppointmentKindSlug.ExamWellnessExotic,
  [AppointmentKindSlug.ExamProgress]: AppointmentKindSlug.ExamProgressExotic,
  [AppointmentKindSlug.ExamUrgent]: AppointmentKindSlug.ExamUrgentExotic,
};
